import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';

interface IUserProps {
    fName: string;
    lName: string;
    email: string;
    password: string;
    token: string;
    _id: string;
}

export interface IAuthContextProps {
    user: string;
    setUser?(username: string, userData: Partial<IUserProps>): void; // Update the type to accept userData
    userData: Partial<IUserProps>;
}

const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
    children: ReactNode;
}

export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
    const [user, setUserState] = useState<string>(localStorage.getItem('facit_authUsername') || '');
    const [userData, setUserData] = useState<Partial<IUserProps>>({});

    useEffect(() => {
        localStorage.setItem('facit_authUsername', user);
    }, [user]);


    const setUser = (username: string, userDetails: Partial<IUserProps>) => {
        setUserState(username);
        setUserData(userDetails);
        localStorage.setItem('facit_authUsername', username); // Store username
        localStorage.setItem('facit_authUserData', JSON.stringify(userDetails)); // Store user data
    };
    
    useEffect(() => {
        if (localStorage.getItem('facit_authUserData')) {
            const userData = JSON.parse(localStorage.getItem('facit_authUserData') || '');
            setUserData(userData);
        }
    }, [localStorage.getItem('facit_authUserData')]);

    const value = useMemo(
        () => ({
            user,
            setUser,
            userData,
        }),
        [user, userData],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;